<template>
<div class="content" >
  <router-view v-slot="{ Component }">
      <!-- <transition name="move" mode="out-in"> -->
          <keep-alive>
              <component :is="Component" />
          </keep-alive>
      <!-- </transition> -->
  </router-view>
</div>
</template>
<script>
export default {
  name: 'mainContent',
  data() {
    return {

    }
  },
  methods: {

  },
  created() {

  },
  mounted() {

  }
}
</script>

<style scoped lang='less'>
.content {
    width: 100%;
    height: 100%;
}
</style>
